<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'UnitType',
  props: { value: String },
  computed: {
    text() {
      // 何があるか不明なのでとりあえず大文字にしておく
      switch (this.value) {
        case 'cost_plus_margin':
          return '配信単価を変動'
        default:
          return this.value.toUpperCase()
      }
    },
  },
}
</script>
